import { useState, useEffect } from "react";
import { Badge, Flex, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { toTitleCase } from "utils/text-utils";
import LocalSpinner from "components/LocalSpinner";

/**
 *
 * @param {Object} props
 * @param {string} props.field
 * @param {string} props.status
 * @param {string[]} props.values
 * @param {string} props.label Can be false to suppress the label. Unset means toTitleCase(field)
 * @param {function} props.valueLabeller
 * @param {function} props.handleChange
 * @param {string} props.colorScheme
 * @returns
 */
export default function StatusToggle({
  field,
  status,
  values = ["HIGH", "MEDIUM", "LOW"],
  label,
  valueLabeller,
  handleChange,
  colorScheme,
  colorSchemeForValue,
  title,
  changeDisabled, // aka readOnly
  taskStatus, // HACK: so we can see queued
}) {
  // Note: use a local spinner to avoid blocking the rest of the UI -- less distracting for the user, and it lets them flow through a few edits
  const [isLoading, setIsLoading] = useState(false);
  // Give fast UI feedback to the user
  const [localValue, setLocalValue] = useState(status);
  useEffect(() => {
    // if the server value changes, update the local value
    setLocalValue(status);
  }, [status]);
  const handleChangeWithSpinner = (field, value) => () => {
    setLocalValue(value);
    setIsLoading(true);
    handleChange(field, value).finally(() => {
      setIsLoading(false);
    });
  };
  if (!valueLabeller) valueLabeller = toTitleCase;
  if (colorSchemeForValue && colorSchemeForValue[localValue]) {
    colorScheme = colorSchemeForValue[localValue];
  }
  // HACK allow NONE for completeness (meaning no-answer)
  if (field === "completeness" || field === "confidence") {
    if (!values.includes("NONE")) {
      values = values.concat("NONE");
    }
  }
  return (
    <Menu>
      <MenuButton
	    title={title}
        as={Badge}
        fontSize="body.xxs"
        width="fit-content"
        px={2}
        py={1}
        borderRadius="md"
        colorScheme={colorScheme}
        _hover={{
          cursor: "pointer",
        }}
      >
        <Flex direction="row">
          {label === false ? null : label || toTitleCase(field) + ": "}
          {valueLabeller(localValue)}
          {isLoading && <LocalSpinner size="sm" />}
        </Flex>
      </MenuButton>
      {!changeDisabled && (
        <MenuList maxHeight="250px" /* why wanted??*/ overflowY="auto">
          {values.map((value) => (
            <MenuItem fontSize="body.xs" key={value} onClick={handleChangeWithSpinner(field, value)}>
              {valueLabeller(value)} {taskStatus === "queued"? " (queued)" : ""}
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Menu>
  );
}
